<div class="form-section">
  <div class="section-header">
    <div class="section-label">
      <span class="section-num">01.A</span>
      <span class="section-title">Channel identity</span>
    </div>
    <span class="section-hint">Immutable after creation</span>
  </div>

  <div class="field-row-name-code">
    <div class="form-group">
      <label class="field-label" for="channelName">Name</label>
      <input id="channelName" type="text" class="custom-input"
        [class.is-invalid]="submitted && nameError"
        [(ngModel)]="formData.name"
        (ngModelChange)="nameErrorChange.emit(false)"
        placeholder="e.g. Modern Trade"
        autocomplete="off" />
      @if (submitted && nameError) {
        <div class="field-error">Channel name is required</div>
      }
    </div>

    <div class="form-group">
      <label class="field-label" for="channelCode">
        Code
        <span class="field-badge">immutable</span>
      </label>
      <div class="code-input-wrapper">
        <input id="channelCode" type="text" class="custom-input"
          [class.is-invalid]="(submitted && codeError) || codeValidationState === 'taken'"
          [class.is-valid]="codeValidationState === 'valid'"
          [value]="formData.code"
          (input)="onCodeInput($any($event.target).value)"
          placeholder="e.g. CH-MT"
          autocomplete="off"
          maxlength="12" />
        @if (codeValidationState === 'checking') {
          <span class="code-state-indicator code-state-indicator--checking">
            <span class="spinner"></span>
          </span>
        }
        @if (codeValidationState === 'valid') {
          <span class="code-state-indicator code-state-indicator--valid">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M2 6.5L5 9.5L10 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        }
        @if (codeValidationState === 'taken') {
          <span class="code-state-indicator code-state-indicator--taken">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M3 3L9 9M9 3L3 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
        }
      </div>
      @if (codeValidationState === 'taken') {
        <div class="field-error">This code is already taken — choose another</div>
      } @else if (submitted && codeError) {
        <div class="field-error">Channel code is required</div>
      } @else if (codeValidationState === 'valid') {
        <div class="field-success">Code is available</div>
      } @else {
        <div class="field-hint">Letters, numbers and hyphens only. Cannot be changed after creation.</div>
      }
    </div>
  </div>

  <div class="form-group" style="margin-top: 1rem">
    <label class="field-label" for="channelDesc">Description</label>
    <textarea id="channelDesc" class="custom-input custom-textarea" rows="3"
      [(ngModel)]="formData.description"
      placeholder="Describe this channel's scope and purpose..."></textarea>
  </div>
</div>

<div class="section-divider"></div>

<div class="form-section">
  <div class="section-header">
    <div class="section-label">
      <span class="section-num">01.B</span>
      <span class="section-title">Lifecycle</span>
    </div>
    <span class="section-hint">Activation rules</span>
  </div>

  <div class="lifecycle-toggle">
    <button class="lifecycle-btn" [class.lifecycle-btn--active]="formData.active"
      (click)="formData.active = true">
      <span class="lifecycle-dot lifecycle-dot--active"></span>
      Active
    </button>
    <button class="lifecycle-btn" [class.lifecycle-btn--active]="!formData.active"
      (click)="formData.active = false">
      <span class="lifecycle-dot lifecycle-dot--inactive"></span>
      Inactive
    </button>
  </div>

  <p class="lifecycle-note">
    Deactivating a channel preserves all linked POS data but stops new POS from being created
    in this channel. Existing POS continue to operate but cannot be moved to another channel
    without explicit revalidation.
  </p>
</div>
